/**
 * 左侧步骤栏：模块有数据时显示绿色对勾。
 * 基本信息（工作室/品牌/思政微课）：名称有值即视为已填。
 * 组件需提供 sections，并可用 sectionRefMap 覆盖默认 ref 映射。
 */
const DEFAULT_SECTION_REF_MAP = {
  baseInfo: "baseInfoRef",
  teamInfo: "teamInfoRef",
  teachAdd: "teachAddRef",
  budget: "budgetRef",
  capitalExpenditure: "capitalExpenditureRef",
  scientificeAdd: "scientificeAddRef",
  activityPlanAdd: "activityPlanRef",
  result: "resultRef",
  activity: "activityRef",
  teamBuilding: "teamBuildingRef",
  practiceBase: "practiceBaseRef",
  honor: "honorRef",
  brand: "brandRef",
  annualPlan: "annualPlanRef",
  brandBuilding: "teamBuildingRef",
  educatingPeople: "educatingPeopleRef",
  achievement: "achievementRef",
  brandPropaganda: "PropagandaRef",
};

export default {
  data() {
    return {
      sectionFilledMap: {},
      _sectionFillTimers: [],
    };
  },
  watch: {
    "baseInfo.id"() {
      this.scheduleSectionFilledRefresh();
    },
    "baseInfo.name"() {
      this.refreshSectionFilled();
    },
    activeSection() {
      this.refreshSectionFilled();
    },
    jxing(val) {
      if (val === false) this.scheduleSectionFilledRefresh();
    },
  },
  mounted() {
    this.scheduleSectionFilledRefresh();
  },
  beforeDestroy() {
    this.clearSectionFillTimers();
  },
  methods: {
    getSectionRefMap() {
      return Object.assign({}, DEFAULT_SECTION_REF_MAP, this.sectionRefMap || {});
    },
    sectionStepClass(i) {
      const filled = !!this.sectionFilledMap[this.sections[i].id];
      return {
        active: i === this.activeSection,
        "is-filled": filled && i !== this.activeSection,
      };
    },
    sectionStepMark(i) {
      if (i === this.activeSection) return "✎";
      if (this.sectionFilledMap[this.sections[i].id]) return "✓";
      return "";
    },
    resolveSectionComp(sectionId) {
      const refName = this.getSectionRefMap()[sectionId];
      if (!refName) return null;
      let comp = this.$refs[refName];
      if (Array.isArray(comp)) comp = comp[0];
      return comp || null;
    },
    /** 工作室/品牌/微课基本信息：名称有值即打对勾 */
    checkBaseInfoHasName() {
      const comp = this.resolveSectionComp("baseInfo");
      const name =
        (comp && comp.info && comp.info.name) ||
        (this.baseInfo && this.baseInfo.name) ||
        "";
      return String(name).trim().length > 0;
    },
    checkSectionHasData(sectionId) {
      if (sectionId === "baseInfo") {
        return this.checkBaseInfoHasName();
      }
      const comp = this.resolveSectionComp(sectionId);
      if (!comp) return false;
      if (Array.isArray(comp.dataList) && comp.dataList.length > 0) {
        return true;
      }
      // 思政微课补充材料等表单型模块
      if (comp.info && comp.info.id) return true;
      if (Array.isArray(comp.fileList) && comp.fileList.length > 0) {
        return true;
      }
      if (
        comp.info &&
        String(comp.info.type) === "1" &&
        comp.info.name &&
        comp.info.filePath
      ) {
        return true;
      }
      return false;
    },
    refreshSectionFilled() {
      if (!this.sections || !this.sections.length) return;
      const map = {};
      this.sections.forEach((sec) => {
        map[sec.id] = this.checkSectionHasData(sec.id);
      });
      this.sectionFilledMap = map;
    },
    clearSectionFillTimers() {
      (this._sectionFillTimers || []).forEach((t) => clearTimeout(t));
      this._sectionFillTimers = [];
    },
    scheduleSectionFilledRefresh() {
      this.clearSectionFillTimers();
      this.$nextTick(() => {
        this.refreshSectionFilled();
        [400, 1000, 2000, 3500].forEach((ms) => {
          this._sectionFillTimers.push(
            setTimeout(() => this.refreshSectionFilled(), ms)
          );
        });
      });
    },
  },
};
